module.exports = __webpack_public_path__ + "img/blog6-logo-2.d284088a.webp";